module.exports = __webpack_public_path__ + "img/icon-check-solid.7d6a3071.svg";